<template>
	<div class="card">
		<ToastPrime position="bottom-left"/>
		<PrimeFileUpload 
			ref="fileUploadPrime"
			name="files[]" 
			:multiple="isMultiple" 
			accept=".xlsx,.csv,.doc,.docx,.txt,.jpeg,.jpg,.png,.pdf,.ppt,.pptx" 
			@select="onSelectedFiles"
		>
			<template #header="{ chooseCallback }">
				<div style="width:100%" class="flex flex-wrap justify-between items-center flex-1 gap-4">
					<div style="display: flex; gap: 0.5rem; justify-content: flex-end; margin-bottom: 0.5rem">
						<span></span>
						<ButtonPrime v-tooltip.top="'Input'" icon="pi pi-images" rounded variant="outlined" severity="secondary" @click="chooseCallback()"></ButtonPrime>
						<ButtonPrime v-tooltip.top="'Cancel'" icon="pi pi-times" rounded variant="outlined" severity="danger" :disabled="!files || files.length === 0" @click="clearCallback"></ButtonPrime>
					</div>
				</div>
			</template>

			<template #content="{ uploadedFiles }">
				<div class="d-flex flex-column gap-4">
					<!-- Pending -->
					<div v-if="files.length > 0">
						<label>Pending</label>
						<div class="d-flex flex-wrap gap-3">
							<div v-for="(file, index) in files" :key="file.name + file.type + file.size" class="relative p-3 rounded border d-flex flex-column align-items-center gap-2" style="position: relative; width: 180px;">
								<ButtonPrime size="small" icon="pi pi-times" variant="outlined" rounded severity="danger" style="position: absolute; top: 5px; right: 5px; z-index: 10;" @click="onRemoveTemplatingFile(file, index)"/>

								<div style="width: 100px; height: 100px; overflow: hidden;">
									<img v-if="['png', 'jpeg', 'jpg'].includes(getFileExtension(file.name))" role="presentation" :alt="file.name" :src="file.objectURL" style="width: 100%; height: 100%; object-fit: contain;"/>
									<i v-else :class="getFileIcon(file.name)" style="font-size: 6rem;"></i>
								</div>
								<small class="fw-bold text-truncate" style="max-width: 150px;">{{ file.name }}</small>
								<div><small>{{ formatSize(file.size) }}</small></div>
								<!-- <Badge size="small" value="Pending" severity="warn" /> -->
							</div>
						</div>
					</div>

					<!-- Completed -->
					<div v-if="uploadedFiles.length > 0">
						<label>Completed</label>
						<div class="d-flex flex-wrap gap-3">
							<div v-for="file in uploadedFiles" :key="file.name + file.type + file.size" class="relative p-3 rounded border d-flex flex-column align-items-center gap-2" style="position: relative;">
								<div style="width: 100px; height: 100px; overflow: hidden;">
									<img v-if="['png', 'jpeg', 'jpg'].includes(getFileExtension(file.name))" role="presentation" :alt="file.name" :src="file.objectURL" style="width: 100%; height: 100%; object-fit: contain;"/>
									<i v-else :class="getFileIcon(file.name)" style="font-size: 6rem;"></i>
								</div>
								<small class="fw-bold text-truncate" style="max-width: 150px;">{{ file.name }}</small>
								<div><small>{{ formatSize(file.size) }}</small></div>
								<Badge size="small" value="Completed" severity="success" />
							</div>
						</div>
					</div>
				</div>
				<div v-if="files.length > 0 || uploadedFiles.length > 0" class="text-center mt-3 pb-2">
					<small class="text-muted">Max total: {{ formatSize(maxSize) }} | Current: {{ formatSize(totalSize) }}</small>
				</div>
			</template>

			<template #empty>
				<div v-if="files.length === 0" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; height: 10rem;">
					<div style="display: flex; align-items: center; justify-content: center; width: 6rem; height: 6rem; border-radius: 50%; border: 2px solid #ccc; background-color: #fcfcfc;">
            <i class="pi pi-cloud-upload" style="font-size: 3rem; color: #8c94a3;"></i>
					</div>
					<p class="mt-4 mb-0 text-center">Drag and drop files to here to upload.</p>
				</div>
			</template>
		</PrimeFileUpload>
	</div>
</template>
<script>
export default {
  props: {
    files: {
      type: Array,
      required: true
    },
		isMultiple: {
			type: Boolean,
			default: true,
			required: true
		},
		maxSize: { //satuan byte
			type: Number,
			default: 2097152, //2mb
			required: false
		}
  },
	data() {
		return {
			totalSize: 0,
			totalSizePercent: 0,
			$primevue: null
		}
	},
	methods: {
		onRemoveTemplatingFile(file, index) {
			const parentFilesVal = [...this.files]
			parentFilesVal.splice(index, 1)
			this.$emit("update-files", parentFilesVal)
			this.totalSize -= file.size;
			this.totalSizePercent = (this.totalSize / this.maxSize) * 100;
			this.$refs.fileUploadPrime.clear();
		},
		clearCallback() {
			this.$refs.fileUploadPrime.clear();
			this.$emit("update-files", [])
			this.totalSize = 0;
			this.totalSizePercent = 0;
		},
		onSelectedFiles(event) {
			const updatedFiles = [...this.files]

			event.files.forEach((file) => {
				if (file.size >= this.maxSize) {
					this.$toastNotifPrime("error", "Validation Failed", `File ${file.name} is over ${this.maxSize/1048576}MB`)
					this.$refs.fileUploadPrime.clear();
					return
				} else if ((this.totalSize + file.size) >= this.maxSize) {
					this.$toastNotifPrime("error", "Validation Failed", `All Files is over ${this.maxSize/1048576}MB`)
					this.$refs.fileUploadPrime.clear();
					return
				} else {
					if (!this.files.some(f => f.name === file.name)) {
						updatedFiles.push(file)	
						this.totalSize += file.size;
						this.totalSizePercent = (this.totalSize / this.maxSize) * 100;
					}
				}
			});

			this.$emit('update-files', updatedFiles)
		},
		formatSize(bytes) {
			const k = 1024;
			const dm = 3;
			const sizes = this.$primevue?.config?.locale?.fileSizeTypes || ['B', 'KB', 'MB', 'GB'];

			if (bytes === 0 || !bytes) {
				return `0 ${sizes[0]}`;
			}

			const i = Math.floor(Math.log(bytes) / Math.log(k));
			const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

			return `${formattedSize} ${sizes[i]}`;
		},
		getFileExtension(filename) {
			return filename.split('.').pop().toLowerCase(); // ambil setelah titik terakhir
		},
		getFileIcon(filename) {
			const ext = this.getFileExtension(filename);
			switch (ext) {
				case 'pdf':
					return 'pi pi-file-pdf text-red-500';
				case 'doc':
				case 'docx':
					return 'pi pi-file-word text-blue-500';
				case 'xls':
				case 'xlsx':
					return 'pi pi-file-excel text-green-500';
				case 'ppt':
				case 'pptx':
					return 'pi pi-file-ppt text-orange-500';
				case 'txt':
					return 'pi pi-file text-gray-500';
				default:
					return 'pi pi-file text-primary';
			}
		}
	}
}
</script>
